import { useState, useEffect } from "react";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Modal from "react-modal";
import LoadingPage from "../../components/LoadingPage";
import { toFarsiNumber } from "../../custom/helpers";
import { baseURL } from "../../custom/api";
import { useFetch } from "../../custom/api";

import "../../styles/Recipe.css";
import "../../styles/Colors.css";
import "../../styles/Buttons.css";
import "../../styles/Containers.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

import { dayToWeek } from "../calendar/Calendarr";
import GoToTop from "../../components/GoToTop";
import TopNavbarBack from "../../components/TopNavbarBack";
import DateMealModal from "./components/DateMealModal";
import SelectDayModal from "./components/SelectDayModal";
import ConfirmMealModal from "./components/ConfirmMealModal";
import CookingMode from "./components/CookingMode";
import { ReactComponent as AroundTW } from "../../media/around_the_world.svg";

const Recipe = () => {
  const date = new Date();
  const { myFetch } = useFetch();
  const params = useParams();
  const recipeId = params.id;
  const [recipe, setRecipe] = useState({ ingredients: [], steps: [] });

  const [selectedMeal, setSelectedMeal] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateLabel, setSelectedDateLabel] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showCModal, setShowCModal] = useState(false);
  const [showDModal, setShowDModal] = useState(false);
  const [cookingModeDisplay, setCookingModeDisplay] = useState("none");
  const [day, setDay] = useState(date);
  const [week, setWeek] = useState(dayToWeek(day));
  const [favClass, setFavClass] = useState("");
  const [loading, setLoading] = useState(false);
  const [emptyDateError, setEmptyDateError] = useState("");
  const [emptyMealError, setEmptyMealError] = useState("");

  useEffect(() => {
    setWeek(dayToWeek(day));
  }, [day]);

  const options = {
    صبحانه: "breakfast",
    "میانوعده صبح": "snack1",
    نهار: "lunch",
    "میانوعده عصر": "snack2",
    شام: "dinner",
    "میانوعده شب": "snack3",
  };

  const handleMealChange = (event) => {
    setSelectedMeal(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch(`recipes/${recipeId}`, { method: "GET" });
      const r = await resp.json();
      setRecipe(r);
      setFavClass(r.is_favorite ? "round-fav" : "round");
    };
    fetchData();
  }, []);

  const handleAdd = async () => {
    let endPoint;
    let method;
    let buttonClass;

    if (recipe.is_favorite) {
      endPoint = "del";
      method = "delete";
      buttonClass = "round";
    } else {
      endPoint = "add";
      method = "post";
      buttonClass = "round-fav";
    }

    let resp = await myFetch(`favorites/${endPoint}`, {
      method: method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ recipe_id: recipeId }),
    });
    if (resp.status == 200) {
      let jsonResponse = await resp.json();
      recipe.is_favorite = jsonResponse.is_favorite;
      setFavClass(buttonClass);
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenDModal = () => {
    setShowDModal(true);
  };

  const handleCloseDModal = () => {
    setShowDModal(false);
    setShowModal(true);
  };

  const handleOpenCModal = async (event) => {
    event.preventDefault();
    setEmptyDateError(false);
    setEmptyMealError(false);
    setLoading(true);
    // validate empty inputs
    if (!selectedDate) {
      setLoading(false);
      setEmptyDateError("نمیگی چه روزی؟");
      return;
    }
    if (!selectedMeal) {
      setLoading(false);
      setEmptyMealError("نمیگی چه وعده‌ای؟");
      return;
    } else {
      setShowCModal(true);
      setShowModal(false);
    }
  };

  const handleCloseCModal = () => {
    setShowCModal(false);
    setShowModal(true);
    setLoading(false);
  };

  const handlePreviousWeek = () => {
    let result = day.setDate(day.getDate() - 7);
    setDay(new Date(result));
  };

  const handleToday = () => {
    setDay(new Date());
  };

  const handleNextWeek = () => {
    let result = day.setDate(day.getDate() + 7);
    setDay(new Date(result));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // send the input value to the server
    let data = {
      meal_type: options[selectedMeal],
      date: selectedDate.toISOString().substring(0, 10),
      recipe_id: recipeId,
    };
    sendDataToServer(data);

    setShowModal(false);
    setShowCModal(false);
    setLoading(false);
  };

  const sendDataToServer = (data) => {
    myFetch("calendar/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((jsonResponse) => {
        // Check the server response and show appropriate toast message
        if (jsonResponse.message === "success") {
          toast.success("غذا به تقویم اضافه شد");
        } else {
          toast.error("مشکلی پیش اومد :( دوباره غذا رو اضافه کن");
        }
      });
  };

  const LockedRecipe = () => {
    return (
      <div>
        <TopNavbarBack
          title=""
          rbuttonIcon={["icon-iconchevron-right"]}
          rbackground={["rectangle1"]}
          lbuttonIcon={["dNone"]}
          lbuttonHref={["null"]}
          lbackground={["null"]}
        />
        <div className="marginTop10 marginSide14">
          <AroundTW className="radius2" alt="AroundTW"></AroundTW>
          <p className="rightAlign">
            برای استفاده از دستورهای غذایی بیشتر و تقویم لازمه اشتراک حرفه‌ای
            داشته باشی.
          </p>
          <div className="marginTop20 marginBottom5">
            <Link to="/subscription" className="primaryPurple">
              زیر 2 دقیقه فعالش کن
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const OpenRecipe = () => {
    return (
      <div className="backDarkColor">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeButton={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <div className="R-navbar">
          <TopNavbarBack
            title=""
            rbuttonIcon={["icon-iconchevron-right"]}
            rbackground={["rectangle1"]}
            lbuttonIcon={["dNone"]}
            lbuttonHref={["null"]}
            lbackground={["null"]}
          />
        </div>

        <div className="recipe-container">

          <div className="recipe-info-container">
            <img
              className="R-img"
              src={recipe.image_path && `${baseURL}/${recipe.image_path}`}
              alt={recipe.recipe_name}
            />
            <div className="R-info">
              <p className="food-name">{recipe.recipe_name}</p>
              <p className="P-txt">{recipe.cooking_duration}دقیقه</p>
              <div className="spc-between">
                <div onClick={handleAdd} className={favClass}>
                  <span className="icon-iconsave"></span>
                </div>
                <Link to="" onClick={handleOpenModal} className="round">
                  <span className="icon-iconplus"></span>
                </Link>
              </div>
            </div>
          </div>
          <div className="R-box">
            <p className="H-txt">مواد لازم</p>

            {recipe.ingredients.map((ing) => {
              return (
                <div className="spc-between P-txt">
                  <p>{ing.name}</p>
                  <p>
                    {ing.amount !== 0 && toFarsiNumber(ing.amount)} {ing.unit}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="R-box">
            <p className="H-txt">دستور پخت</p>
            {recipe.steps.map((step) => {
              return <p className="P-txt">{step.step_description}</p>;
            })}
          </div>
        </div>
   <div className="bottomFixedPosition">
            <button
              onClick={() => {
                setCookingModeDisplay("block");
              }}
              className="fill-container heading-3"
            >
              رفتن به حالت پخت
              <div className="caption-1 yekan">
                برای استفاده از دستیار صوتی، اجازه میکروفن لازمه
              </div>
            </button>
          </div>
        <CookingMode
          steps={recipe.steps}
          display={cookingModeDisplay}
          setCookingModeDisplay={setCookingModeDisplay}
        ></CookingMode>

        <DateMealModal
          selectedDateLabel={selectedDateLabel}
          showModal={showModal}
          handleCloseModal={handleCloseModal}
          setShowDModal={setShowDModal}
          handleMealChange={handleMealChange}
          selectedMeal={selectedMeal}
          handleOpenCModal={handleOpenCModal}
          options={options}
          loading={loading}
          emptyDateError={emptyDateError}
          emptyMealError={emptyMealError}
        ></DateMealModal>

        <SelectDayModal
          showDModal={showDModal}
          handleCloseDModal={handleCloseDModal}
          handleToday={handleToday}
          setSelectedDate={setSelectedDate}
          setSelectedDateLabel={setSelectedDateLabel}
          setShowDModal={setShowDModal}
          setShowModal={setShowModal}
          handlePreviousWeek={handlePreviousWeek}
          handleNextWeek={handleNextWeek}
          week={week}
        ></SelectDayModal>

        <ConfirmMealModal
          showCModal={showCModal}
          handleCloseCModal={handleCloseCModal}
          selectedMeal={selectedMeal}
          selectedDateLabel={selectedDateLabel}
          recipe={recipe}
          handleSubmit={handleSubmit}
        ></ConfirmMealModal>

        <GoToTop />
      </div>
    );
  };

  return (
    <div>
      {recipe.recipe_id === null ? (
        <LockedRecipe></LockedRecipe>
      ) : !recipe.recipe_id ? (
        <LoadingPage />
      ) : (
        <OpenRecipe></OpenRecipe>
      )}
    </div>
  );
};

export default Recipe;
